<ion-content #pageTop class="background">
  <div class="header-page">
    <app-header-not-buttons></app-header-not-buttons>

    <app-title-three title="Olvidé mi clave"></app-title-three>
  </div>

  <form [formGroup]="forgotPasswordForm">
    <ion-grid class="form-data">
      <ion-row>
        <ion-col class="message-forgot">
          <div>
            <ion-label
              >Por favor introduce tu correo electrónico y enviaremos tu nueva
              clave</ion-label
            >
          </div>
          <ion-item>
            <ion-label position="floating" color="tertiary"
              >Correo electrónico</ion-label
            >
            <ion-input
              mode="md"
              formControlName="email"
              maxlength="50"
              id="email"
              type="email"
              [attr.maxlength]="50"
            >
            </ion-input>
          </ion-item>

          <div
            class="div message-errors"
            *ngIf="errorControl.email.errors != null"
          >
            <div
              *ngIf="
          (errorControl.email.touched || errorControl.email.dirty) &&
          errorControl.email.errors.nameText
        "
            >
              <ion-text color="primary" class="messages-alert"
                >Ingrese un correo valido.</ion-text
              >
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!-- Botones -->
    <ion-grid>
      <ion-row>
        <ion-col class="ion-text-center" size="12">
          <button
            [disabled]="forgotPasswordForm.invalid"
            (click)="resetPassword()"
            id="btn-create-modal"
            class="btn-primary-2"
          >
            Solicitar
          </button>
        </ion-col>
        <ion-col class="ion-text-center" size="12">
          <button
            (click)="closeModal()"
            id="btn-edit-modal"
            class="btn-primary btn-close"
          >
            Cerrar
          </button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>
